<template>
  <div
    class="switch-btn"
    :class="{active: isActive}"
    v-on:click="onClick"
  >
    <div class="switch-btn__img-wrapper">
      <img
        :src="require(`@/assets/images/jacket_${this.type}.png`)"
        :alt="`jacket ${type}`"
        class="switch-btn__img"
      >
    </div>
    <div class="switch-btn__label">{{ type }}</div>
  </div>
</template>

<script>
export default {
  name: 'SwitchSideButton',

  props: {
    type: String,
    isActive: Boolean
  },

  methods: {
    onClick () {
      this.$emit('onSwitch', this.type);
    }
  }
};
</script>

<style scoped>
  .switch-btn {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    padding: 15px 15px 0;

    &.active {
      .switch-btn__img-wrapper {
        border: 1px solid #1c539c
      }
    }
  }

  .switch-btn__img-wrapper {
    position: relative;
    border: 1px solid transparent;
    margin-bottom: 3px;
  }

  .switch-btn__img {
    height: 50px;
  }

  .switch-btn__label {
    color: #c9c9c9;
    font-size: 14px;
    text-transform: uppercase;
  }
</style>
